import React from "react";
import theme from "../../theme";
import styled from "styled-components";
import { Link } from "gatsby";

const Tile = styled.div`
  padding: 3%;
  background-color: #ffffff;
  border-radius: 5px;
  transition: all 0.25s ease-in-out;
  cursor: pointer;

  ${theme.mixins.onEvent} {
    box-shadow: ${theme.shadows.shadow};
  }
`;

const ImageWrapper = styled.div`
  display: block;
  margin: 0 auto;
  height: 230px;
  border-radius: 5px;
  width: 100%;
  overflow: hidden;

  ${theme.screens.xlScreen} {
    max-height: 300px;
  }

  ${theme.screens.smScreen} {
    width: unset;
  }
`;

const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Header = styled.h5`
  font-size: 20px;
  margin-top: 15px;
  min-height: 60px;
  ${theme.screens.xlScreen} {
    min-height: 90px;
  }
  ${theme.screens.mdScreen} {
    min-height: unset;
  }
`;

const Desc = styled.p`
  font-size: 18px;
  color: ${theme.colors.pink};
  margin-top: 4px;
  ${theme.screens.mdScreen} {
    margin-bottom: 25px;
  }
`;

const CareerTile = ({ link, image, header, desc }) => {
  return (
    <Link to={link}>
      <Tile>
        <ImageWrapper>
          <Image src={image} alt=""></Image>
        </ImageWrapper>
        <Header>{header}</Header>
        <Desc>{desc}</Desc>
      </Tile>
    </Link>
  );
};

export default CareerTile;
